import React from 'react';

import {
  WizardScreen,
  FooterMode
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFormError } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-error/wizard-form-error';
import { WizardFormValidationErrorSummary } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-validation-error-summary/wizard-form-validation-error-summary';

import { CreateNewConsolidatedForecastForm } from '../../../components/forecast/create-new-consolidated-forecast-form';
import { ForecastFormHelpText } from '../../../components/form-elements/forecast-form-help-text/forecast-form-help-text';
import { useCreateConsolidatedForecastWizardContext } from '../../../contexts/create-consolidated-forecast-wizard-context';

export interface ConsolidatedForecastFormWizardScreenProps {
  error?: string | boolean;
  onClose: () => void;
  onCreate: () => void;
}

export const ConsolidatedForecastFormWizardScreen = ({
  error,
  onClose,
  onCreate
}: ConsolidatedForecastFormWizardScreenProps) => {
  const { form, kind, view } = useCreateConsolidatedForecastWizardContext();
  const { consolidatedForecasts, subEntityForecasts } = view.state;

  const { ...formState } = form;

  return (
    <WizardScreen onCancel={onClose} onCreate={onCreate} footerMode={FooterMode.CREATE}>
      <>
        {error && <WizardFormError mb={3} message={typeof error === 'string' ? error : undefined} />}
        <WizardFormValidationErrorSummary errors={formState.errors} mb={3} />
        <CreateNewConsolidatedForecastForm
          {...formState}
          forecasts={consolidatedForecasts}
          subEntityForecasts={subEntityForecasts}
        />
        <ForecastFormHelpText kind={kind} />
      </>
    </WizardScreen>
  );
};
